import { Capacitor } from "@capacitor/core";
import { Filesystem, Directory } from "@capacitor/filesystem";
import successModal from "@/components/mixin/toast";

export default {
	mixins: [successModal],
	methods: {
		blobToBase64(blob) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.onloadend = () => {
					const base64 = reader.result?.split(",")[1] || "";
					resolve(base64);
				};
				reader.onerror = reject;
				reader.readAsDataURL(blob);
			});
		},
		async getUniqueDownloadPath(directory, basePath) {
			const lastDot = basePath.lastIndexOf(".");
			const ext = lastDot >= 0 ? basePath.slice(lastDot) : "";
			const nameWithoutExt = lastDot >= 0 ? basePath.slice(0, lastDot) : basePath;
			let path = basePath;
			let count = 0;
			for (;;) {
				try {
					await Filesystem.stat({ path, directory });
					count += 1;
					path = `${nameWithoutExt} (${count})${ext}`;
				} catch {
					return path;
				}
			}
		},
		async saveBlobToDevice(blob, filename, options = {}) {
			const { resumePrefix = true } = options;
			const base64 = await this.blobToBase64(blob);
			const sanitized = filename.replace(/[^a-zA-Z0-9.-]/g, "_");
			const basePath = resumePrefix ? `Resume_${sanitized}` : sanitized;
			const directory = Directory.Documents;
			const path = await this.getUniqueDownloadPath(directory, basePath);
			await Filesystem.writeFile({
				path,
				data: base64,
				directory,
			});
		},
		async downloadResumeFile(downloadUrl, filename) {
			if (Capacitor.isNativePlatform()) {
				const response = await fetch(downloadUrl, { cache: "no-store" });
				const blob = await response.blob();
				await this.saveBlobToDevice(blob, filename);
				this.$nextTick(() => {
					this.successModal("Successfully downloaded","QR Code has been downloaded");
				})
			} else {
				const link = document.createElement("a");
				link.href = downloadUrl;
				link.download = filename;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				this.$nextTick(() => {
					this.successModal("Successfully downloaded","QR Code has been downloaded");
				})
			}
		},
	},
};
